export default "__VITE_ASSET__DMq2IFiw__"